// generate FH widget open buttons based on specific href string
if (typeof FHflow !== 'undefined' && typeof FHitem !== 'undefined' && typeof FHshortname !== 'undefined' && typeof FHref !== 'undefined') {
    // console.log(FHflow, FHitem, FHshortname, FHref);

    $('a[href="#fh-open"]').each(function () {
        $(this).addClass('fh-open')
            .attr('data-flow-id', FHflow)
            .attr('data-item-id', FHitem)
            .attr('data-account', FHshortname)
            .attr('data-ref', FHref);
    });
}
